<div>
    <p-confirmPopup></p-confirmPopup>

    <!-- Dialogo de Edicao/Criacao -->
    <p-dialog
        [(visible)]="isEditing"
        [header]="editingTeacher?.id ? 'Editar Professor' : 'Novo Professor'"
        [modal]="true"
        [style]="{width: '500px'}"
        [draggable]="false"
        [resizable]="false"
        (onHide)="cancelEdit()"
    >
        <form [formGroup]="teacherForm" class="flex flex-column gap-3 p-3">
            <!-- Nome -->
            <div class="flex flex-column gap-1">
                <label class="font-semibold">Nome *</label>
                <input
                    pInputText
                    formControlName="name"
                    placeholder="Nome completo do professor"
                    [class.ng-invalid]="teacherForm.get('name')?.invalid && teacherForm.touched"
                    [class.ng-dirty]="teacherForm.get('name')?.dirty"
                />
                <small class="p-error" *ngIf="nameError">{{ nameError }}</small>
            </div>

            <!-- Email -->
            <div class="flex flex-column gap-1">
                <label class="font-semibold">Email *</label>
                <input
                    pInputText
                    type="email"
                    formControlName="email"
                    placeholder="email@exemplo.com"
                    [class.ng-invalid]="teacherForm.get('email')?.invalid && teacherForm.touched"
                    [class.ng-dirty]="teacherForm.get('email')?.dirty"
                />
                <small class="p-error" *ngIf="emailError">{{ emailError }}</small>
            </div>

            <!-- Bio -->
            <div class="flex flex-column gap-1">
                <label class="font-semibold">Biografia</label>
                <textarea
                    pInputTextarea
                    formControlName="bio"
                    rows="3"
                    placeholder="Breve biografia do professor..."
                    style="resize: none;"
                    [class.ng-invalid]="teacherForm.get('bio')?.invalid && teacherForm.touched"
                ></textarea>
                <small class="p-error" *ngIf="bioError">{{ bioError }}</small>
                <small class="text-500 text-sm">{{ teacherForm.get('bio')?.value?.length || 0 }}/500 caracteres</small>
            </div>
        </form>

        <ng-template pTemplate="footer">
            <div class="flex justify-content-end gap-2">
                <p-button
                    label="Cancelar"
                    severity="secondary"
                    [text]="true"
                    (onClick)="cancelEdit()"
                    [disabled]="submitting"
                ></p-button>
                <p-button
                    [label]="editingTeacher?.id ? 'Salvar Alteracoes' : 'Criar Professor'"
                    icon="pi pi-check"
                    (onClick)="saveTeacher()"
                    [loading]="submitting"
                    [disabled]="!isFormValid"
                ></p-button>
            </div>
        </ng-template>
    </p-dialog>

    <!-- Tabela de Professores -->
    <p-table
        #dt
        styleClass="p-datatable-gridlines p-datatable-striped"
        [scrollable]="true"
        scrollHeight="40vh"
        [value]="listTeachers"
        dataKey="id"
        sortField="name"
        [globalFilterFields]="['name', 'role', 'email', 'bio']"
    >
        <ng-template pTemplate="caption">
            <div class="flex justify-content-between align-items-center">
                <span class="font-bold text-xl">Instrutores</span>
                <div class="flex gap-2">
                    <p-button
                        icon="pi pi-filter"
                        outlined
                        pTooltip="Filtrar Tabela"
                        (onClick)="showFilters = !showFilters"
                    ></p-button>
                    <p-button
                        icon="pi pi-plus"
                        label="Adicionar"
                        (onClick)="openNewTeacherDialog()"
                    ></p-button>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="name" style="width: 20%">Nome <p-sortIcon field="name"/></th>
                <th pSortableColumn="role" style="width: 15%">Funcao <p-sortIcon field="role"/></th>
                <th style="width: 10%">Foto</th>
                <th pSortableColumn="email" style="width: 20%">Email <p-sortIcon field="email"/></th>
                <th pSortableColumn="bio" style="width: 25%">Bio <p-sortIcon field="bio"/></th>
                <th style="width: 10%">Acoes</th>
            </tr>
            <tr *ngIf="showFilters">
                <th>
                    <p-columnFilter
                        type="text"
                        field="name"
                        matchMode="contains"
                        placeholder="Nome"
                        ariaLabel="Filtrar por nome"
                        [showMenu]="false"
                        [showClearButton]="false"
                    />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="role"
                        matchMode="contains"
                        placeholder="Funcao"
                        ariaLabel="Filtrar por funcao"
                        [showMenu]="false"
                        [showClearButton]="false"
                    />
                </th>
                <th></th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="email"
                        matchMode="contains"
                        placeholder="Email"
                        ariaLabel="Filtrar por email"
                        [showMenu]="false"
                        [showClearButton]="false"
                    />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="bio"
                        matchMode="contains"
                        placeholder="Bio"
                        ariaLabel="Filtrar por bio"
                        [showMenu]="false"
                        [showClearButton]="false"
                    />
                </th>
                <th></th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-teacher let-ri="rowIndex">
            <tr>
                <!-- Nome -->
                <td>
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-user text-600" *ngIf="!teacher.name"></i>
                        {{teacher.name || '-'}}
                    </div>
                </td>

                <!-- Funcao -->
                <td>
                    <span class="text-600" *ngIf="teacher.role">{{teacher.role}}</span>
                    <span *ngIf="!teacher.role" class="text-500">-</span>
                </td>

                <!-- Foto -->
                <td>
                    <div class="flex align-items-center justify-content-center gap-2">
                        <div *ngIf="teacher.profilePhotoUrl" class="relative">
                            <img
                                [src]="teacher.profilePhotoUrl"
                                alt="Foto do professor"
                                style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;"
                                (error)="onImageError($event)"
                            />
                            <p-button
                                icon="pi pi-search"
                                [text]="true"
                                severity="info"
                                [rounded]="true"
                                [style]="{'position': 'absolute', 'bottom': '-5px', 'right': '-5px', 'padding': '2px'}"
                                (onClick)="openPhoto(teacher.profilePhotoUrl)"
                                pTooltip="Ver foto"
                                [styleClass]="'p-button-sm'"
                            ></p-button>
                        </div>
                        <p-fileUpload
                            mode="basic"
                            *ngIf="!teacher.profilePhotoUrl"
                            name="photo"
                            [multiple]="false"
                            [style]="{borderRadius: '50px', backgroundColor: 'transparent', color: 'var(--primary-color)'}"
                            chooseIcon="pi pi-camera"
                            [disabled]="uploadingPhoto"
                            accept="image/*"
                            maxFileSize="5000000"
                            [auto]="true"
                            (onSelect)="onFileSelect($event, teacher)"
                            invalidFileLimitMessageDetail="Maximo 5MB"
                            invalidFileLimitMessageSummary="Formato invalido!"
                        ></p-fileUpload>
                        <p-progressSpinner
                            *ngIf="uploadingPhoto"
                            [style]="{width: '25px', height: '25px'}"
                            strokeWidth="4"
                        ></p-progressSpinner>
                    </div>
                </td>

                <!-- Email -->
                <td>
                    <span *ngIf="teacher.email" class="text-sm">{{teacher.email}}</span>
                    <span *ngIf="!teacher.email" class="text-500">-</span>
                </td>

                <!-- Bio -->
                <td>
                    <span
                        class="text-sm text-600"
                        style="max-width: 200px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;"
                        [pTooltip]="teacher.bio"
                        tooltipPosition="top"
                    >
                        {{teacher.bio || '-'}}
                    </span>
                </td>

                <!-- Acoes -->
                <td>
                    <div class="flex gap-1 justify-content-center">
                        <p-button
                            icon="pi pi-pencil"
                            severity="warning"
                            [rounded]="true"
                            [text]="true"
                            pTooltip="Editar"
                            (onClick)="initEdit(teacher)"
                        ></p-button>

                        <p-button
                            icon="pi pi-trash"
                            severity="danger"
                            [rounded]="true"
                            [text]="true"
                            pTooltip="Excluir"
                            (onClick)="ConfirmDelete($event, teacher, ri)"
                        ></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr *ngIf="loaded">
                <td colspan="6">
                    <div class="flex flex-column align-items-center justify-content-center p-4">
                        <ng-lottie
                            [options]="{path: 'assets/Animations/animationNotFoundPages.json'}"
                            width="8vw"
                            height="8vw"
                        ></ng-lottie>
                        <h4 class="text-600 mt-2">
                            Nenhum professor encontrado
                        </h4>
                        <p-button
                            label="Adicionar primeiro professor"
                            icon="pi pi-plus"
                            class="mt-2"
                            [link]="true"
                            (onClick)="openNewTeacherDialog()"
                        ></p-button>
                    </div>
                </td>
            </tr>

            <tr *ngIf="!loaded">
                <td colspan="6">
                    <div class="flex justify-content-center align-items-center w-full p-4">
                        <p-progressSpinner ariaLabel="loading" />
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
